export const EMPLOYEE_SAVINGS_PASS_PERCENTAGE = {
  PEI: 8,
  PEE: 8,
  PEEG: 8,
  PERECOI: 16,
  PERECO: 16,
  PERECOG: 16,
  PERCOI: 16,
  PERCO: 16,
  PERO: 16, // put valid value there when known
  PERU: 16, // put valid value there when known
  PER: 16, // put valid value there when known
  ARTICLE_83: 16, // put valid value there when known
  ARTICLE_82: 16, // put valid value there when known
  PERECOER: 16,
  ER_EXTERNAL: 16,
};
export const EMPLOYEE_SAVINGS_MAX_MATCHING_CONTRIBUTION_PERCENTAGE = 300;
export const EMPLOYEE_SAVINGS_MAX_MINIMUM_TENURE_MONTHS = 3;
// Per employee and per calendar year
export const EMPLOYEE_SAVINGS_MAX_UNILATERAL_MATCHING_CONTRIBUTION_CENTS = 6000_00;

export const EMPLOYEE_SAVINGS_MAX_COMPANY_VP_WARNING = 8000_00;

export const EMPLOYEE_SAVINGS_BRACKETS_MIN_NUM = 1;
export const EMPLOYEE_SAVINGS_BRACKETS_MAX_NUM = 5;

export const EMPLOYEE_SAVINGS_MIN_ORDER_AMOUNT_IN_CENTS = 10_00;
export const EMPLOYEE_SAVINGS_MIN_MANAGED_PLAN_CONTRIBUTION_AMOUNT_CENTS = 50_00;
export const EMPLOYEE_SAVINGS_MIN_NON_SELL_ALL_ARBITRAGE_ORDER_AMOUNT_CENTS = 10_00;
export const EMPLOYEE_SAVINGS_MIN_PAYOUT_ORDER_AMOUNT_CENTS = 1_00;

export const EMPLOYEE_SAVINGS_CSG_TAX_RATE = 0.092;
export const EMPLOYEE_SAVINGS_CRDS_TAX_RATE = 0.005;

// Funds invested in when employees make no choice, set through the contract type definitions
// AXA Génération Tempéré Solidaire
export const AXA_DEFAULT_FUND_ISIN = 'FR0014001H69';
// MH Epargne Monétaire, in each Malakoff Humanis share class
export const MALAKOFF_L_DEFAULT_FUND_ISIN = '990000204799';
export const MALAKOFF_M_DEFAULT_FUND_ISIN = '990000204809';
export const MALAKOFF_H_DEFAULT_FUND_ISIN = '990000204819';

// Fund lists of the contract type definitions
// The AXA funds new plans start with
export const AXA_PREFILLED_FUND_ISINS = [
  'FR0014006PE1',
  'FR0014001H69',
  'FR0014001FE3',
  'LU1937143664',
  'FR0014008R11',
  'LU0251662135',
  'FR0014006OM7',
  'LU1280196004',
  'FR0014006NL1',
  'FR0010611293',
  'FR0011261197',
  'LU2257980289',
  'FR0010187898',
  'LU1164220854',
  'FR0013417524',
  'FR0014006L43',
];
// The AXA funds a PERECO-I universe must keep
export const AXA_PERECOI_REQUIRED_FUND_ISINS = [
  'FR0014006PE1',
  'FR0014001H69',
  'FR0014001FE3',
  'LU1937143664',
  'FR0014008R11',
  'FR0014006OM7',
];
// Malakoff Humanis funds by share class: the "Coeur" range, then the "Complémentaire" one
export const MALAKOFF_L_CORE_FUND_ISINS = [
  MALAKOFF_L_DEFAULT_FUND_ISIN,
  '990000204869',
  '990000204949',
  '990000205049',
  '990000205129',
  '990000205189',
  '990000205299',
  '990000205339',
  '990000205219',
  '990000205599',
];
export const MALAKOFF_L_FUND_ISINS = [
  ...MALAKOFF_L_CORE_FUND_ISINS,
  '990000204839',
  '990000204899',
  '990000204979',
  '990000205019',
  '990000205079',
  '990000205159',
  '990000205249',
  '990000205269',
  '990000205369',
  '990000206329',
];
export const MALAKOFF_M_FUND_ISINS = [
  MALAKOFF_M_DEFAULT_FUND_ISIN,
  '990000204879',
  '990000204959',
  '990000205059',
  '990000205139',
  '990000205199',
  '990000205229',
  '990000205309',
  '990000205349',
  '990000205589',
  '990000204849',
  '990000204909',
  '990000134279',
  '990000205029',
  '990000205089',
  '990000205169',
  '990000205259',
  '990000205279',
  '990000205379',
  '990000206339',
];
export const MALAKOFF_H_FUND_ISINS = [
  MALAKOFF_H_DEFAULT_FUND_ISIN,
  '990000204889',
  '990000204969',
  '990000205069',
  '990000205119',
  '990000205179',
  '990000205209',
  '990000205289',
  '990000205329',
  '990000136249',
  '990000204859',
  '990000204929',
  '990000134289',
  '990000205039',
  '990000205099',
  '990000205149',
  '990000205239',
  '990000126429',
  '990000205359',
  '990000206349',
];
// Malakoff Humanis "Externe" range, only in L shares
export const MALAKOFF_EXTERNAL_FUND_ISINS = [
  '990000206009',
  '990000206019',
  '990000206039',
  '990000206059',
  '990000097559',
  '990000122809',
  '990000080549',
  '990000122829',
  '990000206109',
  '990000206379',
];

export const FULLY_MANAGED_PLAN_SUPPORT_LABEL = 'Profil actuel';

export const EMPLOYEE_SAVINGS_SELL_ALL_PORTFOLIO_QTY_THRESHOLD_RATE = 0.95;

export const EMPLOYEE_SAVINGS_VOLUNTARY_PAYMENT_LIMIT_SINGLE_DOCUMENTS_REQUIRED = 50000_00;
export const EMPLOYEE_SAVINGS_VOLUNTARY_PAYMENT_LIMIT_SINGLE = 8000_00;

export const TAIGA_VOLUNTARY_PAYMENT_LIMIT_SINGLE_DOCUMENTS_REQUIRED_LIMIT_YEARLY = 50000_00;
export const TAIGA_VOLUNTARY_PAYMENT_LIMIT_SINGLE = 8000_00;

export const EMPLOYEE_SAVINGS_RETIREMENT_AGE = 64;

export const EMPLOYEE_SAVINGS_CAMPAIGN_DEFAULT_ALLOCATION_PERECOI_REIMBURSEMENT_CLAIM_LIMIT_DAYS = 30;
